import styled from "styled-components";

export const NothingChosenContainer = styled.div`
  margin-top: 25px;
`;

export const NothingChosenText = styled.p`
  font-size: 1.4rem;
  font-style: italic;
  text-align: center;
  font-weight: 500;
`;

export const EmptyFolderImage = styled.img`
  width: 350px;
  height: 350px;
  margin: 0 auto;
  object-fit: contain;
  display: block;
`;
